
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientionwarmingmattress() {



  const cardData =
  {
    keyword: 'Patient Warming Mattress',
    heading: 'Pharmacle Health Care Private Limited: Patient Warming Mattress',
    headingDescription: 'Pharmacle Health Care Private Limited offers premium-quality Patient Warming Mattress solutions in Kolkata, specially designed to provide consistent thermal support during surgical and critical care procedures. Our warming mattresses help maintain normothermia by evenly distributing heat, reducing the risk of hypothermia and enhancing patient comfort. Trusted by top hospitals and healthcare professionals, our patient warming mattresses are durable, easy to operate, and built with the latest technology. Choose Pharmacle Health Care for the best warming mattresses in Kolkata to ensure superior patient care and safety.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "Advanced Patient Warming Mattress for Optimal Thermal Support",
    "description": "Pharmacle Health Care Private Limited offers innovative patient warming mattresses designed to maintain consistent body temperature during surgeries and recovery. Built for safety, comfort, and better clinical outcomes, these mattresses are trusted by healthcare providers nationwide."
  },
  {
    "title": "Best Patient Warming Mattresses for Hospitals and ICUs",
    "description": "Our high-performance warming mattresses are ideal for operating rooms, intensive care units, and recovery wards. They effectively prevent hypothermia, improve patient safety, and accelerate recovery times."
  },
  {
    "title": "Reliable Patient Warming Mattress for Enhanced Patient Care",
    "description": "Pharmacle Health Care Private Limited delivers durable and reliable patient warming mattresses that ensure uninterrupted warmth and comfort. A trusted choice for medical professionals seeking consistent thermal care solutions."
  },
  {
    "title": "High-Performance Patient Warming Mattress for Medical Use",
    "description": "Engineered with advanced heat distribution technology, our warming mattresses are suitable for surgeries, trauma cases, and long-term patient care. They improve clinical efficiency and enhance patient recovery outcomes."
  },
  {
    "title": "Buy Patient Warming Mattress for Safe and Comfortable Recovery",
    "description": "Pharmacle Health Care Private Limited provides premium warming mattresses designed for ease of use and patient comfort. Ideal for post-operative recovery and routine hospital treatments."
  },
  {
    "title": "Cutting-Edge Patient Warming Mattress for Clinical Efficiency",
    "description": "Equipped with advanced temperature regulation features, our warming mattresses ensure patients remain at stable body temperatures throughout critical medical procedures."
  },
  {
    "title": "Affordable and Durable Patient Warming Mattresses",
    "description": "Pharmacle Health Care Private Limited offers cost-effective warming mattresses that combine durability with efficiency. Perfect for high-usage environments like hospitals, trauma centers, and recovery units."
  },
  {
    "title": "Trusted Supplier of Patient Warming Mattresses",
    "description": "Hospitals and clinics trust Pharmacle Health Care Private Limited for superior patient warming mattresses that deliver consistent thermal support and long-lasting durability."
  },
  {
    "title": "Pediatric and Adult Patient Warming Mattress Solutions",
    "description": "Our warming mattresses are designed for both pediatric and adult patients, offering adjustable warmth settings for safe, tailored temperature management across age groups."
  },
  {
    "title": "Hospital-Grade Patient Warming Mattress for Superior Care",
    "description": "Enhance patient comfort and reduce surgical complications with our hospital-grade warming mattresses. A vital addition to ICUs, operating theaters, and emergency care setups."
  }
],

   "services": [
    {
      "name": "Patient Warming Mattress",
      "description": "Pharmacle Health Care provides patient warming mattresses designed to maintain body temperature during medical procedures and recovery. These mattresses offer uniform heat distribution for enhanced comfort and safety."
    },
    {
      "name": "Heated Medical Mattress",
      "description": "Our heated medical mattresses are built to deliver consistent warmth in clinical settings. These mattresses support temperature regulation during surgeries and postoperative care, minimizing hypothermia risk."
    },
    {
      "name": "Surgical Warming Pads",
      "description": "Pharmacle Health Care offers surgical warming pads that provide targeted heating during operations. These pads are essential for maintaining normothermia and improving surgical outcomes."
    },
    {
      "name": "Temperature Control Mattress",
      "description": "We supply temperature control mattresses designed for precise thermal regulation during patient care. These devices help prevent temperature-related complications across various medical procedures."
    },
    {
      "name": "Hospital Thermal Mattress",
      "description": "Our hospital thermal mattresses offer safe and effective warmth to patients in surgery and recovery rooms. They ensure optimal body temperature is maintained, contributing to improved healing and comfort."
    },
    {
      "name": "Operating Room Heating Mattress",
      "description": "Pharmacle Health Care provides operating room heating mattresses tailored for use in surgical environments. These mattresses help maintain stable patient temperatures in highly controlled clinical settings."
    },
    {
      "name": "Intraoperative Patient Warming Pad",
      "description": "We offer intraoperative patient warming pads that deliver focused heat during surgical procedures. These pads enhance thermoregulation and help reduce perioperative complications."
    }
  ],
  "tableData": [
    ["- Patient Warming Mattress", "- Heated Medical Mattress"],
    ["- Surgical Warming Pads", "- Temperature Control Mattress"],
    ["- Hospital Thermal Mattress", "- Operating Room Heating Mattress"],
    ["- Intraoperative Patient Warming Pad"]
  ],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced Patient Warming Mattresses in Kolkata, engineered to provide consistent and precise temperature control during medical treatments. Our technology helps prevent hypothermia, ensuring patient safety and comfort."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "Our Patient Warming Mattresses are part of a broad range of warming products in Kolkata, designed for use in surgical, critical care, and recovery settings. We tailor solutions to keep patients warm and comfortable throughout their medical procedures."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Built with high-quality materials, our Patient Warming Mattresses are durable and designed for repeated clinical use. Each mattress is thoroughly tested to ensure long-lasting performance and reliability in hospitals and clinics across Kolkata."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are top priorities. Our Patient Warming Mattresses provide gentle, controlled warmth to prevent temperature-related complications, offering a safe and soothing experience for patients in Kolkata."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Designed to fit various healthcare environments in Kolkata, our Patient Warming Mattresses adapt seamlessly to hospital beds, operating tables, and recovery units. We collaborate with healthcare providers to meet specific clinical requirements."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s Patient Warming Mattresses are designed for quick and easy integration with existing medical warming systems in Kolkata. Their user-friendly design allows efficient implementation without disrupting clinical workflows."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation in Kolkata to help healthcare facilities select the most suitable Patient Warming Mattresses. Our support team offers ongoing maintenance and service to ensure equipment reliability."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, ensuring patient safety and comfort is our mission. Our Patient Warming Mattresses are crafted to maintain safe body temperatures during critical procedures, delivering exceptional care across Kolkata."
    }
]

























  }

const faqData = [
  {
    question: "What is a Patient Warming Mattress?",
    answer: "A Patient Warming Mattress is a temperature-regulating mattress used in medical settings to keep patients warm during surgeries or extended recovery periods. It helps prevent hypothermia by providing consistent heat underneath the patient’s body."
  },
  {
    question: "How does the Patient Warming Mattress work?",
    answer: "The mattress connects to a warming unit that circulates warm air or fluid throughout its internal channels. This creates an even, controlled heat distribution that helps maintain the patient’s core body temperature."
  },
  {
    question: "Is the Patient Warming Mattress available in Kolkata?",
    answer: "Yes, Pharmacle Health Care Private Limited offers high-quality Patient Warming Mattresses in Kolkata. These devices are widely used in hospitals and clinics to improve patient outcomes and safety."
  },
  {
    question: "Can the Patient Warming Mattress be used for all patients?",
    answer: "Yes, the mattress is generally safe for most patient types when used by trained medical professionals. It is especially useful for patients undergoing long surgeries, critical care, or recovery from anesthesia."
  },
  {
    question: "What are the benefits of using a Patient Warming Mattress?",
    answer: "Benefits include maintaining normothermia, reducing surgical complications, improving patient comfort, enhancing recovery, and minimizing the risk of hypothermia-related issues."
  },
  {
    question: "How can I order a Patient Warming Mattress from Pharmacle Health Care?",
    answer: "To order, contact Pharmacle Health Care Private Limited. Our team will help you choose the right product and coordinate delivery and support services to your facility in Kolkata."
  }
];

const testimonialsData = [
  {
    text: "The Patient Warming Mattress from Pharmacle Health Care has greatly improved thermal care for our patients during long surgeries. It’s reliable, easy to use, and highly effective.",
    name: "Dr. Aniket Ghosh"
  },
  {
    text: "We’ve integrated Pharmacle Health Care’s Patient Warming Mattress into our post-op units. It ensures patients remain warm and comfortable, especially during recovery from anesthesia.",
    name: "Eastside Hospital, Kolkata"
  }
];




  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



 
  
const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Patient Warming Mattress",
  "description": "High-quality Patient Warming Mattresses designed for effective temperature control and patient comfort during surgical and medical procedures. Ensure optimal thermoregulation with our heated medical mattresses.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5154"
  }
};


  

  return (
    <div>
  <Helmet>
  <title>Patient Warming Mattress | Contact: +91 8956322311</title>
  <meta
    name="description"
    content="High-quality Patient Warming Mattresses for effective temperature control during surgical and medical procedures. Contact us at +91 8956322311."
  />
  <meta
    name="keywords"
    content="Patient Warming Mattress, Heated Medical Mattress, Surgical Warming Pads, Temperature Control Mattress, Hospital Thermal Mattress, Operating Room Heating Mattress, Intraoperative Patient Warming Pad"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/63.png' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientionwarmingmattress;